import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Button, Card, DatePicker, Form, Select, Spin, message } from 'antd'
import { faviconDynamicFunction } from '../../util/methods'
import axios from 'util/Api'
import moment from 'moment'

const { Option } = Select

const DailyFuelProcessReportNotification = ({
    loading,
    authUser,
    form
}) => {
    const { getFieldDecorator } = form
    const [processing, setProcessing] = useState(false)
    const [organisationLoading, setOrganisationLoading] = useState(false)
    const [organisations, setOrganisations] = useState([])

    React.useEffect(() => {
        let mounted = true
        const fetchOrganisations = async () => {
            try {
                setOrganisationLoading(true)
                const response = await axios.get('/organisation/distinct')
                const orgs = Array.isArray(response && response.data) ? response.data : []
                if (mounted) {
                    setOrganisations(orgs)
                }
            } catch (error) {
                if (mounted) {
                    setOrganisations([])
                    message.error('Failed to load organisations')
                }
            } finally {
                if (mounted) {
                    setOrganisationLoading(false)
                }
            }
        }
        fetchOrganisations()
        return () => {
            mounted = false
        }
    }, [])

    const onSubmit = (e) => {
        e.preventDefault()
        form.validateFields(async (err, values) => {
            if (err) {
                message.error('Please select a valid date')
                return
            }

            try {
                setProcessing(true)
                const dateString = moment(values.date).format('YYYY-MM-DD')
                const payload = { dateString }
                if (values.organisationId) {
                    payload.organisationId = values.organisationId
                }
                await axios.post('/daily-fuel-data/process-report-notification', payload)
                message.success(`Daily fuel process report notification triggered for ${dateString}`)
            } catch (error) {
                console.error('Error triggering daily fuel process report notification:', error)
                const errMessage = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Failed to trigger daily fuel process report notification'
                message.error(errMessage)
            } finally {
                setProcessing(false)
            }
        })
    }

    faviconDynamicFunction(authUser)

    return (
        <Spin spinning={loading || processing}>
            <Card className={`gx-card-metrics`}>
                <span>
                    <h2>Daily Fuel Report Notification</h2>
                    <p>Select a date and trigger report notification processing for that day</p>
                </span>

                <div style={{ marginTop: '30px', marginLeft: '2%', width: '50%' }}>
                    <Form layout="vertical" onSubmit={onSubmit}>
                        <Form.Item label="Organisation (Optional)">
                            {getFieldDecorator("organisationId")(
                                <Select
                                    showSearch
                                    allowClear
                                    placeholder="All Organisations"
                                    style={{ width: '100%' }}
                                    loading={organisationLoading}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option.props.children || '').toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {organisations.map((org) => (
                                        <Option key={String(org._id)} value={String(org._id)}>
                                            {org.name || org.code || String(org._id)}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>

                        <Form.Item label="Select Date">
                            {getFieldDecorator("date", {
                                rules: [{ required: true, message: 'Date is required!' }],
                            })(
                                <DatePicker
                                    format="DD/MM/YYYY"
                                    placeholder="Select Date"
                                    style={{ width: '100%' }}
                                    disabledDate={(current) => current && current > moment().endOf('day')}
                                />
                            )}
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                className="gx-mb-0"
                                htmlType="submit"
                                loading={processing}
                                size="large"
                                disabled={processing}
                            >
                                {processing ? 'Triggering...' : 'Trigger Notification'}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Card>
        </Spin>
    )
}

const mapStateToProps = ({ commonData, auth }) => {
    return {
        loading: commonData.loading,
        authUser: auth.authUser || commonData.authUser
    }
}

export default connect(mapStateToProps, {})(Form.create()(DailyFuelProcessReportNotification))
